import React, { useState } from "react";
import { Modal, Header, Button, Form as FormUi, Input } from "semantic-ui-react";
import CreateAxios from "../axiosComponent/create";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { translate } from "react-i18next";

const CreateUserRoleModal = (props, {values}) => {
  const [Role, setRole] = useState('');

const getRoleValue = (data) => {
  setRole(data)
};
const submit = () => {
  if (Role && Role != "") {
  let Payload = {role: Role, module: 'TA'}
  CreateAxios({
    url: `roles`,
    payload: { ...Payload },
  })
    .then((res) => {
      let alert = {
        type: "success",
        messageHeader: "Success",
        messageBody: `Role is created.`,
    };
    props.successAlertDispatcher(alert);
    props.handleClose()
    window.location.reload()
     
    })
    .catch((err) => {
      if (err.data.status === 204) {
        let alert = {
            type: "error",
            messageHeader: "Error",
            messageBody: `Unable to create Role,${err.data.message}`,
        };
        props.errorAlertDispatcher(alert);
        props.handleClose()
    }
 
    });
 
  }
}
  const { t } = props;
  return (
    <div>
      <Modal open={props.openBox} onClose={props.handleClose} size="tiny">
        <Header>{t("modal.title") || "New User Role"}</Header>
        <Modal.Content>
          <Modal.Description>
            <FormUi.Group inline>
              <FormUi.Field>
                <label className="tiny ui form p-bold-600">
                  {t("modal.label") || "Enter User Role"}
                </label>
              </FormUi.Field>
            </FormUi.Group>
            <FormUi.Group inline>
              <FormUi.Field>
                <Input
                    name='role'
                    placeholder={t("modal.placeholder") || "User Role"}
                    type="text"
                    onChange={(e) => getRoleValue(e.target.value) }
                />
              </FormUi.Field>
            </FormUi.Group>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button size="mini"
          className="w3-button w3-blue w3-hover-blue w3-round w3-small"
          onClick={(data) => submit()}
          >
            {t("submit") || "Submit"}
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    success: (alert) => dispatch(successAlertDispatcher(alert)),
    error: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};

export default connect(null,{
  successAlertDispatcher,
  errorAlertDispatcher,
})(translate("user_role")(CreateUserRoleModal));
